/** A faixa da grade de Frota: o último ciclo do Protheus e, para quem edita a frota,
 *  a importação dos eixos por CSV (14/10/2026), que alimenta o esperado do pedágio. */
import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { FileUp } from 'lucide-react'
import { FrotaProtheusBanner } from '../../shared/protheus/ProtheusBanner'
import { useCan } from '../../core/auth/useCan'
import { useI18n } from '@/core/i18n/useI18n'
import { ImportarEixosDialog } from './ImportarEixosDialog'

export function FrotaBanner() {
  const { t } = useI18n()
  const can = useCan()
  const [aberto, setAberto] = useState(false)
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      <FrotaProtheusBanner />
      {can('master_data.edit') && (
        <>
          <Box sx={{ flex: 1 }} />
          <Button size="small" variant="outlined" startIcon={<FileUp size={16} />} onClick={() => setAberto(true)}>
            {t('cadastros.eixos.abrir')}
          </Button>
          <ImportarEixosDialog open={aberto} onClose={() => setAberto(false)} />
        </>
      )}
    </Box>
  )
}
